import { useState } from 'react';
import { ArrowRight, User, Users, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SectionHeader } from '../common';

export default function TradeTerminalSection() {
  const [dir, setDir] = useState('LONG');
  const [mode, setMode] = useState('single');
  return (
    <section className="section">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="panel p-6 reveal order-2 lg:order-1" style={{ boxShadow: '0 30px 90px rgba(0,0,0,0.5)' }}>
            <div className="flex items-center justify-between mb-5">
              <span className="font-mono text-[12px] text-[var(--muted)]">EXECUTION · BTCUSDT</span>
              <div className="inline-flex p-0.5 rounded-lg" style={{ background: 'var(--surface-2)', border: '1px solid var(--border)' }}>
                {['LONG', 'SHORT'].map((d) => (
                  <button key={d} onClick={() => setDir(d)} className="px-3.5 h-8 rounded-md font-mono text-[12px] font-semibold transition-all" style={{ background: dir === d ? (d === 'LONG' ? 'var(--emerald-soft)' : 'rgba(240,97,109,.14)') : 'transparent', color: dir === d ? (d === 'LONG' ? 'var(--emerald)' : 'var(--down)') : 'var(--muted-2)' }}>{d}</button>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <TField label="Asset" value="BTCUSDT" /><TField label="Risk %" value="1.0%" />
              <TField label="Quantity" value="0.42 BTC" /><TField label="Entry" value="$71,180" />
              <TField label="Stop Loss" value="$69,400" color="var(--down)" /><TField label="Take Profit" value="$76,200" color="var(--emerald)" />
            </div>
            <div className="mt-5">
              <div className="font-mono text-[11px] text-[var(--muted-2)] mb-2">ACCOUNTS</div>
              <div className="grid grid-cols-2 gap-2">
                {[['single', 'Single Account', User], ['multi', 'Multiple Accounts', Users]].map(([k, label, Icon]) => (
                  <button key={k} onClick={() => setMode(k)} className="flex items-center gap-2 p-3 rounded-lg text-[13px] transition-all" style={{ border: `1px solid ${mode === k ? 'var(--gold-border)' : 'var(--border)'}`, background: mode === k ? 'var(--gold-soft)' : 'var(--surface-2)', color: mode === k ? '#fff' : 'var(--muted)' }}><Icon size={15} className={mode === k ? 'text-[var(--gold-2)]' : ''} /> {label}</button>
                ))}
              </div>
              {mode === 'multi' && <p className="font-mono text-[11px] text-[var(--muted-2)] mt-2">3 connected accounts · synchronized execution</p>}
            </div>
            <button className="btn-emerald rounded-lg h-11 w-full mt-5 flex items-center justify-center gap-2 text-[14px]"><Zap size={16} /> Execute {dir}</button>
          </div>

          <div className="reveal order-1 lg:order-2">
            <SectionHeader eyebrow="Trade Terminal" title="From signal to execution." sub="Turn a validated signal into a live position with defined risk — across a single account or many, from one disciplined terminal." />
            <ul className="mt-8 flex flex-col gap-3.5">
              {['Defined risk on every order', 'Single and multi-account execution', 'Permission-based exchange connectivity', 'Clean, reviewable execution history'].map((f) => (
                <li key={f} className="flex items-center gap-3 text-[15px] text-white"><span className="w-5 h-5 rounded-md flex items-center justify-center shrink-0" style={{ background: 'var(--gold-soft)' }}><span className="w-1.5 h-1.5 rounded-full" style={{ background: 'var(--gold-2)' }} /></span>{f}</li>
              ))}
            </ul>
            <div className="mt-8"><Link to="/trade-terminal" className="btn-gold inline-flex items-center gap-2 rounded-xl h-12 px-7 text-[15px] font-semibold">Explore Trade Terminal <ArrowRight size={16} /></Link></div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TField({ label, value, color }) {
  return (
    <div className="panel-2 p-3">
      <div className="font-mono text-[10px] text-[var(--muted-2)] tracking-wide">{label.toUpperCase()}</div>
      <div className="font-mono text-[15px] font-semibold mt-1" style={{ color: color || 'var(--white)' }}>{value}</div>
    </div>
  );
}
